module.exports = __webpack_public_path__ + "static/media/green2.652d3dee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/green2.svg
// module id = 1333
// module chunks = 31